module.exports = __webpack_public_path__ + "static/media/msg-success.a6e96bf9.svg";